export const PLAN_CONFIG = {
  free: {
    id: 'free',
    name: 'Free',
    label: 'For individuals',
    description: 'Get started with local-first analytics. No credit card required.',
    priceMonthly: 0,
    priceYearly: 0,
    uploadsPerMonth: 5,
    queriesPerMonth: 50,
    storageGB: 0.5,
    stripeProductId: null,
    stripePriceMonthlyId: null,
    stripePriceYearlyId: null,
    popular: false,
    perks: [
      'Local-first processing',
      '5 file uploads/month',
      '50 AI queries/month',
      'Basic charts & tables',
      'CSV & Excel export',
      'Community support'
    ],
    limitations: [
      'No cloud sync',
      'No team features',
      'Limited file size (50MB)'
    ]
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    label: 'For power users',
    description: 'Unlimited analytics with cloud sync and priority support.',
    priceMonthly: 19,
    priceYearly: 190,
    savings: 38,
    uploadsPerMonth: null, // unlimited
    queriesPerMonth: null, // unlimited
    storageGB: 10,
    stripeProductId: process.env.REACT_APP_STRIPE_PRO_PRODUCT_ID || null,
    stripePriceMonthlyId: process.env.REACT_APP_STRIPE_PRO_PRICE_MONTHLY_ID || null,
    stripePriceYearlyId: process.env.REACT_APP_STRIPE_PRO_PRICE_YEARLY_ID || null,
    popular: true,
    perks: [
      'Everything in Free, plus:',
      'Unlimited uploads & queries',
      'Cloud sync & backup',
      '10 GB storage',
      'PDF report export',
      'Priority email support',
      'Advanced visualizations',
      'Query history & favorites'
    ],
    limitations: []
  },
  team: {
    id: 'team',
    name: 'Team',
    label: 'For small teams',
    description: 'Collaborate with your team on shared dashboards and data.',
    priceMonthly: 49,
    priceYearly: 490,
    savings: 98,
    uploadsPerMonth: null,
    queriesPerMonth: null,
    storageGB: 50,
    stripeProductId: process.env.REACT_APP_STRIPE_TEAM_PRODUCT_ID || null,
    stripePriceMonthlyId: process.env.REACT_APP_STRIPE_TEAM_PRICE_MONTHLY_ID || null,
    stripePriceYearlyId: process.env.REACT_APP_STRIPE_TEAM_PRICE_YEARLY_ID || null,
    popular: false,
    perks: [
      'Everything in Pro, plus:',
      'Up to 5 team members',
      'Shared dashboards',
      '50 GB team storage',
      'Role-based permissions',
      'Slack integration',
      'API access',
      'Dedicated support'
    ],
    limitations: []
  },
  enterprise: {
    id: 'enterprise',
    name: 'Enterprise',
    label: 'For organizations',
    description: 'Custom solutions with SSO, audit logs, and dedicated support.',
    priceMonthly: null,
    priceYearly: null,
    uploadsPerMonth: null,
    queriesPerMonth: null,
    storageGB: null,
    stripeProductId: null,
    stripePriceMonthlyId: null,
    stripePriceYearlyId: null,
    popular: false,
    perks: [
      'Everything in Team, plus:',
      'Unlimited team members',
      'SSO/SAML authentication',
      'Audit logs & compliance',
      'Custom integrations',
      'On-premise deployment',
      'SLA guarantee',
      'Dedicated account manager'
    ],
    limitations: []
  }
};

export const PLAN_ORDER = ['free', 'pro', 'team', 'enterprise'];

export const getPlanById = (planId) => {
  return PLAN_CONFIG[planId] || PLAN_CONFIG.free;
};

export const getPlanFeatureLimit = (planId, feature) => {
  const plan = getPlanById(planId);
  switch (feature) {
    case 'uploads':
      return plan.uploadsPerMonth;
    case 'queries':
      return plan.queriesPerMonth;
    case 'storage':
      return plan.storageGB;
    default:
      return null;
  }
};

export const formatPlanPrice = (plan, interval = 'monthly') => {
  if (plan.priceMonthly === null) return 'Custom';
  if (plan.priceMonthly === 0) return 'Free';

  const price = interval === 'yearly'
    ? Math.round(plan.priceYearly / 12)
    : plan.priceMonthly;

  return `$${price}`;
};
